import { useState } from 'react';

export default function ShareButton() {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const url = window.location.href;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="relative">
      <button
        type="button"
        onClick={handleCopy}
        className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 cursor-pointer"
      >
        <i className="ri-link"></i>
        复制链接
      </button>
      {copied && (
        <div className="absolute -top-11 left-0 z-10 flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-1.5 text-xs text-background-50 animate-fade-in">
          <i className="ri-check-line text-accent-300"></i>
          链接已复制（演示）
        </div>
      )}
    </div>
  );
}